import { NgClass } from "@angular/common";
import {
  Component,
  computed,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute, RouterOutlet } from "@angular/router";
import { IconComponent } from "@claas/claas-ui-components";
import { ProductDetailBreadcrumb } from "../../shared/components/breadcrumb/breadcrumb";
import { ProductDetailAside } from "../../shared/components/product-detail-aside/product-detail-aside";
import { ConfigService } from "../../shared/config/config.service";
import {
  pathRouteDataHelper$,
  pathRouteParametersHelper$,
} from "../../shared/helpers/path-params.helper";
import { DefaultProduct } from "../../shared/pia-api/generated";
import { AuthImagePipe } from "../../shared/pipes/auth-image.pipe";
import { ProductFamilyFavoritesService } from "../../shared/services/product-family-favorites.service";

@Component({
  selector: "claas-product-detail",
  imports: [
    AuthImagePipe,
    IconComponent,
    NgClass,
    ProductDetailAside,
    ProductDetailBreadcrumb,
    RouterOutlet,
  ],
  templateUrl: "./product-detail.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./product-detail.scss",
})
export class ProductDetailComponent {
  config = inject(ConfigService);
  route = inject(ActivatedRoute);
  favorites = inject(ProductFamilyFavoritesService);

  data = toSignal(pathRouteDataHelper$());
  params = toSignal(pathRouteParametersHelper$());
  productSeries = computed(
    () => this.data()?.["productDetails"] as DefaultProduct | null,
  );
  product = computed(() => {
    const productId = this.params()?.["productId"];
    return this.data()?.["productDescendants"]?.find(
      (productDescendant: DefaultProduct) => {
        return productDescendant.ID === productId;
      },
    ) as DefaultProduct | null;
  });
  favoritesList = toSignal(this.favorites.getIdsIncluded());
  isFavorite = computed(() =>
    this.favoritesList()?.includes(this.productSeries()?.ID as string),
  );

  handleFavorites(id: string) {
    if (!this.favoritesList()?.includes(id)) {
      this.favorites.add(id);
    } else {
      this.favorites.remove(id);
    }
  }
}
